// Domain
import { AssociatedProductEntity } from '../entities/associated-product-entity';

export default class AssociatedProductState {
  loaded = false;

  items: Array<AssociatedProductEntity> = []
}
